var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('ChatWindow',{attrs:{"messages":_vm.messages,"requestUrl":_vm.requestUrl,"requestParams":_vm.requestParams,"focus":_vm.focus,"read-only":_vm.readOnly,"errorName":"message"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fc03230","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/chat-window/chat-window.vue
// module id = MpRM
// module chunks = 1